import { useEffect } from "react";
import "./index.css";
import $ from "jquery";
import { Link } from "react-router-dom";

const Agent = ({ agent }) => {
  const {
    userID,
    agentPhotoURL,
    agentFirstName,
    agentLastName,
    agentTitle,
    agentCellPhone,
    agentOfficePhone,
    language,
  } = agent;

  useEffect(() => {
    $(".agent .lang").matchHeight({ property: "height" });
  }, []);

  return (
    <div className="agent">
      <Link to={`/agent-details/${userID}`} className="agent-img">
        <img src={agentPhotoURL} alt="" />
      </Link>
      <h5>
        {agentFirstName} {agentLastName}
      </h5>
      <h6>{agentTitle}</h6>
      {agentCellPhone !== "" && (
        <p>
          Cell Phone : <a href={`tel:${agentCellPhone}`}>{agentCellPhone}</a>
        </p>
      )}
      {agentOfficePhone !== "" && (
        <p>
          Office Phone :{" "}
          <a href={`tel:${agentOfficePhone}`}>{agentOfficePhone}</a>
        </p>
      )}
      <p className="lang">
        {language !== "" ? `Known Languages : ${language}` : ""}
      </p>
      <ul>
        <li>
          <Link to={`/agent-details/${userID}`}>Contact This Realtor</Link>
        </li>
        <li>
          <Link to={`/agent-details/${userID}`}>View Active Listings</Link>
        </li>
      </ul>
    </div>
  );
};

export default Agent;
